import ContactContainer from './components/ContactContainer';
import './assets/scss/main.css';

export default ContactContainer;


// WEBPACK FOOTER //
// ./src/features/Contact/index.js